// parseServerTime converts a server DATETIME string to epoch milliseconds.
//
// The relay stores and sends timestamps in SQLite's native layout —
// "2006-01-02 15:04:05", UTC, space-separated, no `T`, no zone suffix (see
// relay db_time.go `sqlTimeLayout`). iOS WKWebView (JavaScriptCore) returns
// NaN from `Date.parse` on that shape, so the old `Date.parse(x) || Date.now()`
// idiom silently fell back to the ingest time on iOS — corrupting both message
// ordering and the displayed relative-time labels. Parse the fields explicitly
// and anchor them to UTC so every platform agrees.
//
// Also accepts an ISO-8601 string (with `T` and/or a zone) so RFC3339 wire
// values keep working. Returns Date.now() only as a genuine last resort for an
// unrecognized shape.
export function parseServerTime(s: string | null | undefined): number {
  if (s) {
    // "YYYY-MM-DD[ T]HH:MM:SS" with no explicit zone → treat as UTC (how the
    // relay stores it). A trailing zone/offset or fractional seconds means it's
    // already a well-formed ISO string; hand those to Date.parse.
    const m = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})$/.exec(s)
    if (m) {
      return Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +m[6])
    }
    const t = Date.parse(s)
    if (!Number.isNaN(t)) return t
  }
  return Date.now()
}
